import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-2xl mx-auto px-5 py-32 text-center" data-testid="payment-cancel">
      <XCircle size={56} strokeWidth={1.2} className="mx-auto text-[#B89C65]" />
      <h1 className="font-serif text-5xl text-[#1A1A1A] mt-6">Pagamento cancelado</h1>
      <p className="text-[#1A1A1A]/60 mt-4">Sua sacola foi mantida. Você pode finalizar quando quiser.</p>
      <div className="flex gap-4 justify-center mt-10">
        <Link to="/carrinho" className="bg-[#1A1A1A] text-[#F8F7F4] px-8 py-4 overline hover:bg-[#B89C65] transition-colors">Voltar à sacola</Link>
        <Link to="/loja" className="border border-[#1A1A1A]/30 px-8 py-4 overline hover:border-[#B89C65] hover:text-[#B89C65] transition-colors">Continuar comprando</Link>
      </div>
    </div>
  );
}
